/* global axios */
import ApiClient from './ApiClient';

class IvrFlowsAPI extends ApiClient {
  constructor() {
    super('ivr/flows', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { ivr_flow: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { ivr_flow: data });
  }

  delete(id, { deletePublished = false } = {}) {
    const params = deletePublished ? { delete_published: true } : {};
    return axios.delete(`${this.url}/${id}`, { params });
  }

  compile(id) {
    return axios.post(`${this.url}/${id}/compile`);
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }
}

export default new IvrFlowsAPI();
